import RoomImage from "Assets/Images/Civics/EscapeRoom/original_oval.webp";

/** Same asset URL used by the Executive Escape Room panorama. */
export const EXECUTIVE_OVAL_IMAGE = RoomImage;

let prefetchStarted = false;

/**
 * Warm the browser cache for original_oval.webp as early as possible
 * (e.g. when Civics is selected) so the Executive Branch game opens faster.
 */
export function prefetchExecutiveOvalImage() {
	if (prefetchStarted || typeof window === "undefined") return;
	prefetchStarted = true;

	const img = new Image();
	img.decoding = "async";
	img.src = RoomImage;

	if (document.head && !document.querySelector('link[data-prefetch-oval="true"]')) {
		const link = document.createElement("link");
		link.rel = "preload";
		link.as = "image";
		link.href = RoomImage;
		link.type = "image/webp";
		link.setAttribute("data-prefetch-oval", "true");
		document.head.appendChild(link);
	}
}
